import * as Yup from "yup";
import { dateToyyyyMMdd } from "../../../util/date";
import { getPatchOperations } from "../../../util/form";
export const firmaAbonnementerForm = (
  firmaId: string,
  firmaAbonnementId?: string,
): FormConfig<FirmaAbonnementerDTO> => {
  return {
    title: "Abonnement",
    lockedValues: [
      { id: "firmaId", value: firmaId },
      { id: "firmaAbonnementId", value: firmaAbonnementId },
    ],
    validationSchema: Yup.object({
      periodeFraDato: Yup.date().nullable().required("Startdato skal være sat"),
      periodeTilDatoInklusiv: Yup.date().nullable(),
      faktureres: Yup.boolean().required("Faktureres skal være sat"),
      antalEksemplar: Yup.number()
        .required("Antal skal være sat")
        .typeError("Antal kan kun være et tal")
        .integer("Antal kan kun være et positivt heltal")
        .positive("Antal kan kun være et positivt heltal"),
    }),
    form: [
      {
        component: "datepicker",
        id: "periodeFraDato",
        initialValue: "",
        label: "Startdato",
        isRequired: true,
      },
      {
        component: "datepicker",
        id: "periodeTilDatoInklusiv",
        initialValue: "",
        label: "Slutdato",
      },
      {
        component: "boolean",
        label: "Faktureres",
        id: "faktureres",
        initialValue: false,
        isRequired: true,
      },
      {
        component: "textinput",
        label: "Antal",
        id: "antalEksemplar",
        initialValue: "",
      },
    ],
    get: `firma/${firmaId}/abonnementer/${firmaAbonnementId}`,
    patch(values: FirmaAbonnementerDTO) {
      const ops = getPatchOperations(values);
      return {
        query: `firma/${firmaId}/abonnementer/${firmaAbonnementId}`,
        body: JSON.stringify(ops),
      };
    },
    post(values) {
      const {
        antalEksemplar,
        faktureres,
        periodeFraDato,
        periodeTilDatoInklusiv,
      } = values;
      return {
        query: `firma/${firmaId}/abonnementer`,
        body: {
          abonnementNr: "1",
          antalEksemplar,
          faktureres,
          periodeFraDato: dateToyyyyMMdd(periodeFraDato),
          periodeTilDatoInklusiv: periodeTilDatoInklusiv
            ? dateToyyyyMMdd(periodeTilDatoInklusiv)
            : "9999-12-31",
        },
      };
    },
    delete() {
      return {
        query: `firma/${firmaId}/abonnementer/${firmaAbonnementId}`,
      };
    },
  };
};
